// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChannelPage/styles.scss
// module id = 1118
// module chunks = 0